import { Platform } from 'react-native';
import { supabase } from '../../shared/supabase/supabaseClient';

function decodeBase64(b64: string, mimeType: string): Uint8Array | Blob {
  if (Platform.OS === 'web') {
    const binary = atob(b64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
  }
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function extensionForMime(mime: string): string {
  if (mime.includes('png')) return 'png';
  if (mime.includes('webp')) return 'webp';
  return 'jpg';
}

export async function uploadOrganizationLogo(params: {
  orgId: string;
  base64: string;
  mimeType: string;
}): Promise<string> {
  const { orgId, base64, mimeType } = params;
  const ext = extensionForMime(mimeType);
  const storagePath = `${orgId}/organization.${ext}`;

  for (const oldExt of ['jpg', 'png', 'webp'].filter((e) => e !== ext)) {
    try {
      await supabase.storage.from('store-logos').remove([`${orgId}/organization.${oldExt}`]);
    } catch {
      // ignore
    }
  }

  const { error: uploadError } = await supabase.storage
    .from('store-logos')
    .upload(storagePath, decodeBase64(base64, mimeType), {
      contentType: mimeType,
      upsert: true,
    });

  if (uploadError) {
    throw new Error(`No se pudo subir el logo: ${uploadError.message}`);
  }

  const { data } = supabase.storage.from('store-logos').getPublicUrl(storagePath);
  return `${data.publicUrl}?t=${Date.now()}`;
}

export async function removeOrganizationLogoStorage(orgId: string): Promise<void> {
  for (const ext of ['jpg', 'png', 'webp']) {
    try {
      await supabase.storage.from('store-logos').remove([`${orgId}/organization.${ext}`]);
    } catch {
      // ignore
    }
  }
}

export async function persistOrganizationLogo(params: {
  logoUrl: string | null;
  focalX?: number;
  focalY?: number;
  zoom?: number;
}): Promise<{
  logoUrl: string | null;
  focalX: number;
  focalY: number;
  zoom: number;
}> {
  const { data, error } = await supabase.rpc('update_my_organization_logo', {
    p_logo_url: params.logoUrl,
    p_focal_x: params.focalX ?? null,
    p_focal_y: params.focalY ?? null,
    p_zoom: params.zoom ?? null,
  });
  if (error) throw error;

  const row = (data ?? {}) as Record<string, unknown>;
  return {
    logoUrl: typeof row.logo_url === 'string' ? row.logo_url : null,
    focalX: Number(row.logo_focal_x ?? 50),
    focalY: Number(row.logo_focal_y ?? 50),
    zoom: Number(row.logo_zoom ?? 1),
  };
}
